import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth/auth.guard';
import { SipGuard } from './shared/guards/sip/sip.guard';
// import { HfGuard } from './shared/guards/health-first/health-first.guard';

const routes: Routes = [
  /*Redirect old php to new sac*/
  {
    path: 'campaign/start_new_campaign.php',
    redirectTo: 'new/crowdfunding/medical'
  },
  {
    path: 'new/campaign/new',
    redirectTo: 'new/crowdfunding/medical'
  },
  {
    path: 'new/browse',
    redirectTo: 'crowdfunding/fundraisers'
  },
  {
    path: 'landing_page/cause/landing.php',
    redirectTo: 'cause/medical-fundraising'
  },
  {
    path: 'cause/medical',
    redirectTo: 'cause/medical-fundraising'
  },
  {
    path: 'cause/help-children-v3',
    redirectTo: 'cause/help-children'
  },
  {
    path: 'new/login',
    loadComponent: () => import('./pages/auto-redirect/auto-redirect.component').then((c) => c.AutoRedirectComponent),
    data: {
      page_name: 'auto_redirect',
      skipLastOrder: true
    }
  },
  {
    path: 'new/crowdfunding',
    loadChildren: () => import('./pages/create-campaign/create-campaign.routes').then(r => r.CreateCampainRoutes),
  },
  {
    path: 'new/campaign-thank-you',
    loadComponent: () => import('./pages/campaign-create-thankyou/campaign-create-thankyou.component').then(c => c.CampaignCreateThankyouComponent),
    data: {
      page_name: 'campaign_thank_you',
      category: 'start fundraiser',
      skipLastOrder: true
    }
  },
  {
    path: 'new/logout',
    loadComponent: () => import('./pages/logout/logout.component').then(c => c.LogoutComponent)
  },
  {
    path: 'new/user/account',
    loadComponent: () => import('./pages/login-via-token/login-via-token.component').then(c => c.LoginViaTokenComponent)
  },
  {
    path: 'new/payment-route',
    loadComponent: () => import('./pages/payment-routing/payment-routing.component').then(c => c.PaymentRoutingComponent),
    data: {
      page_name: 'payment-redirect-page',
      category: 'payment',
      skipLastOrder: true
    }
  },
  {
    path: 'new/show-widget/:tag',
    loadComponent: () => import('./pages/show-widget/show-widget.component').then((c) => c.ShowWidgetComponent),
    data: {
      page_name: 'show_widget'
    }
  },
  {
    path: 'new/access',
    loadComponent: () => import('./pages/token-login/token-login.component').then(c => c.TokenLoginComponent),
    data: {
      page_name: 'token_login'
    }
  },
  {
    path: 'new/test',
    loadComponent: () => import('./pages/test/test.component').then(c => c.TestComponent),
    data: {
      page_name: 'test_page'
    }
  },
  {
    path: 'new/saf',
    loadComponent: () => import('./pages/saf/saf.component').then(c => c.SafComponent),
    data: {
      page_name: 'new_saf',
      skipLastOrder: true
    }
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(c => c.LayoutComponent),
    children: [
      {
        path: 'new/access-denied',
        loadComponent: () => import('./pages/access-denied/access-denied.component').then(c => c.AccessDeniedComponent)
      },
      {
        path: 'new/anniversary',
        loadComponent: () => import('./pages/anniversary/anniversary.component').then(c => c.AnniversaryComponent),
        data: {
          page_name: 'anniversary'
        }
      },
      {
        path: 'crowdfunding/fundraisers',
        loadComponent: () => import('./pages/browse-campaign/browse-campaign.component').then(c => c.BrowseCampaignComponent),
        data: {
          page_name: 'browse_fundraiser',
          category: 'crowdfunding'
        }
      },
      {
        path: 'deardoctor',
        loadComponent: () => import('./pages/dear-doctor/dear-doctor.component').then(c => c.DearDoctorComponent),
        data: {
          page_name: 'dear_doctor'
        }
      },
      {
        path: 'payment-failed',
        loadComponent: () => import('./pages/payment-failed/payment-failed.component').then((c) => c.PaymentFailedComponent),
        data: {
          page_name: 'payment_failed',
          skip_last_order: true
        }
      },
      {
        path: 'new/campaign-review-page',
        loadComponent: () => import('./pages/saf-review/saf-review.component').then(c => c.SafReviewComponent)
      },
      {
        path: 'new/referral',
        loadComponent: () => import('./pages/referral/referral.component').then(c => c.ReferralComponent),
        data: {
          page_name: 'impact_portfolio_refer'
        }
      },
      {
        path: 'new/standalonetip',
        loadComponent: () => import('./pages/standalone-tip/standalone-tip.component').then(c => c.StandaloneTipComponent),
        data: {
          page_name: 'standalonetip'
        }
      },
      {
        path: 'fundraiser/:tag',
        loadComponent: () => import('./pages/fundraiser/fundraiser.component').then(c => c.FundraiserComponent),
        data: {
          page_name: 'campaign'
        }
      },
      {
        path: 'supportfundraiser/:tag',
        loadComponent: () => import('./pages/support-fundraiser/support-fundraiser.component').then(c => c.SupportFundraiserComponent),
        data: {
          page_name: 'campaign'
        }
      },
      {
        path: 'stories/savealife',
        loadComponent: () => import('./pages/story-list/story-list.component').then(c => c.StoryListComponent),
        data: {
          page_name: 'stories_listing'
        }
      },
      {
        path: 'stories/lg/:tag',
        loadComponent: () => import('./pages/lead-gen/lead-gen.component').then(c => c.LeadGenComponent),
        data: {
          page_name: 'teldmleads'
        }
      },
      {
        path: 'stories/:tag',
        loadComponent: () => import('./pages/story/story.component').then(c => c.StoryComponent),
        data: {
          page_name: 'stories'
        }
      },
      {
        path: 'new/stories/:tag',
        loadComponent: () => import('./pages/story-v2/story-v2.component').then(c => c.StoryV2Component),
        data: {
          page_name: 'stories'
        }
      },
      {
        path: 'new/signin',
        loadComponent: () => import('./pages/signin/signin.component').then(c => c.SigninComponent),
        data: {
          page_name: 'sign_in',
          category: 'login',
          skipLastOrder: true
        }
      },
      {
        path: 'new/kettokart/thankyou',
        loadComponent: () => import('./pages/thank-you/thank-you.component').then(c => c.ThankYouComponent),
        data: {
          page_name: 'thank_you',
          skipLastOrder: true
        }
      },
      {
        path: 'new/thankyou',
        loadComponent: () => import('./pages/thank-you/thank-you.component').then(c => c.ThankYouComponent),
        data: {
          page_name: 'thank_you',
          skipLastOrder: true
        }
      },
      {
        path: 'new/pledge-more',
        canActivate: [AuthGuard],
        loadComponent: () => import('./pages/pledge-more/pledge-more.component').then(c => c.PledgeMoreComponent),
        data: {
          page_name: 'sip_returning'
        }
      },
      {
        path: 'new/404',
        loadComponent: () => import('./pages/pagenotfound/pagenotfound.component').then(c => c.PagenotfoundComponent),
      },
      {
        path: 'new/campaign/campaign_update',
        loadComponent: () => import('./pages/campaign-updates/campaign-updates.component').then(c => c.CampaignUpdatesComponent),
        data: {
          page_name: 'update'
        }
      },
      {
        path: 'new/campaign_created',
        loadComponent: () => import('./pages/campaign-create-thankyou-non-medical/campaign-create-thankyou-non-medical.component').then(c => c.CampaignCreateThankyouNonMedicalComponent),
        data: {
          page_name: 'thank_you',
          category: 'crowdfunding',
          skipLastOrder: true
        }
      },
      {
        path: 'crowdfunding',
        loadComponent: () => import('./pages/how-it-works/how-it-works.component').then(c => c.HowItWorksComponent),
        data: {
          page_name: 'crowdfunding',
          category: 'crowdfunding',
          skipLastOrder: true
        }
      },
      {
        path: 'medical-finance-loans',
        loadComponent: () => import('./pages/medical-finance-loans/medical-finance-loans.component').then(c => c.MedicalFinanceLoansComponent),
        data: {
          page_name: 'medical finance loans',
          skipLastOrder: true
        }
      },
      {
        path: 'new/press-club',
        loadComponent: () => import('./common/press-club/press-club.component').then(m => m.PressClubComponent),
      },
      {
        path: 'new/insurance',
        loadComponent: () => import('./pages/insurance-page/insurance-page.component').then(c => c.InsurancePageComponent),
        data: {
          page_name: 'insurance_page',
          skipLastOrder: true
        }
      },
      {
        path: 'new/twfbaahubaliauction',
        loadComponent: () => import('./pages/baahubali-auction/baahubali-auction.component').then(c => c.BaahubaliAuctionComponent),
        data: {
          page_name: 'baahubaliauction'
        }
      },
      {
        path: 'new/portfolio/welcome',
        loadComponent: () => import('./pages/portfolio-welcome/portfolio-welcome.component').then(c => c.PortfolioWelcomeComponent),
        data: {
          page_name: 'impact_welcome',
          sip: true
        }
      },
      {
        path: 'new/portfolio/v2',
        canActivate: [AuthGuard, SipGuard],
        runGuardsAndResolvers: 'always',
        loadComponent: () => import('./pages/portfolio/portfolio.component').then(c => c.PortfolioComponent),
        data: {
          page_name: 'sip_portfolio_v2'
        }
      },
      {
        path: 'new/portfolio',
        canActivate: [AuthGuard, SipGuard],
        runGuardsAndResolvers: 'always',
        loadComponent: () => import('./pages/portfolio/portfolio.component').then(c => c.PortfolioComponent),
        data: {
          page_name: 'impact_portfolio',
          sip: true
        }
      },
      {
        path: 'cause/v2/:cause',
        loadComponent: () => import('./pages/fundraising-cause-v2/fundraising-cause-v2.component').then(c => c.FundraisingCauseV2Component),
        data: {
          page_name: 'medicalanding-v2',
          category: 'cause'
        }
      },
      {
        path: 'cause/:cause',
        loadComponent: () => import('./pages/fundraising-cause/fundraising-cause.component').then(c => c.FundraisingCauseComponent),
        data: {
          page_name: 'medicalanding',
          category: 'cause'
        }
      },
      {
        path: 'new/payment',
        loadComponent: () => import('./pages/payment-otd-page/payment-otd-page.component').then(c => c.PaymentOtdPageComponent),
        data: {
          page_name: 'payment_page',
          category: 'donation'
        }
      },
      {
        path: 'new/about/about-us',
        loadComponent: () => import('./pages/team/team.component').then(c => c.TeamComponent),
        data: {
          skipLastOrder: true
        }
      },
      {
        path: 'new/sip-upi',
        loadComponent: () => import('./pages/sip-onetime-onboard/sip-onetime-onboard.component').then(c => c.SipOnetimeOnboardComponent),
        data: {
          page_name: 'sip_upi_intent',
          sip: true
        }
      },
      {
        path: 'new/success-stories',
        loadComponent: () => import('./pages/success-stories/success-stories.component').then(c => c.SuccessStoriesComponent),
        data: {
          page_name: 'success_stories',
          skipLastOrder: true
        }
      },
      {
        path: 'new/sip-onetime-onboard',
        loadComponent: () => import('./pages/sip-onetime-onboard/sip-onetime-onboard.component').then(c => c.SipOnetimeOnboardComponent),
        data: {
          page_name: 'sip_onetime_onboarding',
          sip: true
        }
      },
      {
        path: 'new/sip/wallet-recharge',
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        loadComponent: () => import('./pages/wallet-recharge/wallet-recharge.component').then(c => c.WalletRechargeComponent),
        data: {
          page_name: 'sip_wallet_recharge',
          sip: true
        }
      },
      {
        path: 'new/sip/welcome',
        loadComponent: () => import('./pages/sip-welcome/sip-welcome.component').then(c => c.SipWelcomeComponent),
        data: {
          page_name: 'sip_welcome',
          sip: true
        }
      },
      {
        path: 'new/sip-portfolio-page',
        canActivate: [AuthGuard],
        loadComponent: () => import('./pages/sip-portfolio/sip-portfolio.component').then(c => c.SipPortfolioComponent),
        data: {
          page_name: 'sip-retention',
          sip: true
        }
      },
      {
        path: 'new/sip/payment-standalone',
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        loadComponent: () => import('./pages/sip-payment-standalone/sip-payment-standalone.component').then(c => c.SipPaymentStandaloneComponent),
        data: {
          page_name: 'sip_welcome',
          sip: true
        }
      },
      {
        path: 'new/sip/change-payment',
        loadComponent: () => import('./pages/sip-change-payment/sip-change-payment.component').then(c => c.SipChangePaymentComponent),
        data: {
          page_name: 'sip_inactive',
          sip: true
        }
      },
      {
        path: 'new/dm/:cause',
        loadComponent: () => import('./pages/dm-story/dm-story.component').then(c => c.DmStoryComponent),
        data: {
          page_name: 'dm_story'
        }
      },
      {
        path: 'new/sip/:cause',
        loadComponent: () => import('./pages/cause-dm-page/cause-dm-page.component').then((c) => c.CauseDmPageComponent),
        data: {
          page_name: 'cause_dm_page'
        }
      },
      {
        path: 'new/sip/medical/v2',
        loadComponent: () => import('./pages/dm-sip-medical/dm-sip-medical.component').then((c) => c.DmSipMedicalComponent),
        data: {
          page_name: 'new_dm_page'
        }
      },
      {
        path: 'new/sip',
        loadComponent: () => import('./pages/dm-sip/dm-sip.component').then((c) => c.DmSipComponent),
        data: {
          page_name: 'impact_portfolio_stories',
          sip: true
        }
      },
      {
        path: 'new/cost-calculator',
        loadComponent: () => import('./pages/cost-calculator/cost-calculator.component').then((c) => c.CostCalculatorComponent),
        data: {
          page_name: 'medical_cost_calculator',
          skipLastOrder: true
        }
      },
      {
        path: 'new/sip-thankyou',
        loadComponent: () => import('./pages/sip-thankyou/sip-thankyou.component').then((c) => c.SipThankyouComponent),
        data: {
          page_name: 'sip_thankyou'
        }
      },
      {
        path: 'new/download-page',
        loadComponent: () => import('./pages/download-page/download-page.component').then(c => c.DownloadPageComponent)
      },
      {
        path: 'hospitals',
        children: [
          {
            path: '**',
            redirectTo: '/new/404'
          }
        ]
      },
      {
        path: '',
        loadComponent: () => import('./pages/home/home.component').then((c) => c.HomeComponent),
        data: {
          page_name: 'home',
          category: 'home',
          skipLastOrder: true
        }
      }
    ]
  },
  {
    path: 'healthfirst',
    loadChildren: () => import('./pages/health-first/health-first.routes').then(r => r.HEALTH_FIRST_ROUTES),
    // canActivate: [HfGuard],
    // runGuardsAndResolvers: 'always'
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
